import RankingsRefereesTable from 'pages/rankings-referees/RankingsRefereesTable';

interface Props {
    contactId?: string;
}

/** A person contact's Rankings referee tab: the Rankings referees list's rows for this person. */
const RankingsRefereeView: React.FC<Props> = ({ contactId }) => {
    if (!contactId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <RankingsRefereesTable contactId={contactId} />
        </div>
    );
};

export default RankingsRefereeView;
